import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SseService } from '../../services/sse.service';
import { Job, JobsService } from '@dal/core';

@Component({
  selector: 'dal-activity-queue-dialog',
  templateUrl: './activityQueueDialog.component.html',
  styleUrl: './activityQueueDialog.component.scss',
})
export class ActivityQueueDialogComponent {
  toggleStates: boolean[] = []; // Array to track toggle state for each section
  
  constructor(private dialogRef: MatDialogRef<ActivityQueueDialogComponent>, private _jobs: JobsService, @Inject(MAT_DIALOG_DATA) public data: Job, private _sse: SseService) { }
  
  toggleDropdown(index: number): void {
    this.toggleStates[index] = !this.toggleStates[index]; // Toggle the specific section
  }

  closePopup(): void {
    this.dialogRef.close();
  }
}
